import React, {useEffect, useState} from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import {Tabs, Button, Layout, Spin, Modal} from "antd";
import PlanRs from './PlanRs';
import ItemRs from './ItemRs';
import ReportHeader from '../Common/ReportHeader';
import {getFindRiskResultManagement, getPdfDownload} from '../Common/api';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import DownloadUrl from '../../components/DownloadUrl';
import {DownloadMd} from '../../components/DownloadPdf';
import MarkdownViewerBig from '../../components/MarkdownViewerBig';

const {Content } = Layout;
const {TabPane} = Tabs;

function ImplementResult() {
    const params = useParams();
    const loadDefaultMessage = "Loading...";
    const [loadMessage, setLoadMessage] = useState(loadDefaultMessage);

    // 변수 선언
    const reportId = params.reportId;
    const [companyCode, setCompanyCode] = useState('');
    const [assetType, setAssetType] = useState('');
    const [reportName, setReportName] = useState('');
    const [tabId, setTabId] = useState('1');
    const [reportInfo, setReportInfo] = useState({});
    const [isDataChange, setIsDataChange] = useState(false);
    const [spinflag, setSpinflag] = useState(true);
    const [spinflagMain,  setSpinflagMain] = useState(false);
    const [markdownVisible, setMarkdownVisible] = useState(false);
    const [markdownContent, setMarkdownContent] = useState('');

    useEffect(() => {
        if(reportInfo) {
            setCompanyCode(reportInfo.com_cd);
            setAssetType(reportInfo.asset_type);
            setReportName(reportInfo.report_nm);
        }
    }, [reportInfo]);

    const [planList, setPlanList] = useState([]);
    const [measureList, setMeasureList] = useState([]);
    const [itemList, setItemList] = useState([]);

    const [sumData, setSumData] = useState({short_term: 0, mid_to_long_term : 0, long_term : 0, 
                        risk_reduction : 0, risk_acception : 0, risk_transfer : 0, risk_evasion : 0, total_risk : 0});

    useEffect(() => {
        findReportList(reportId);
    }, [reportId]);

    // useEffect(() => {
    //     let s_data = {short_term: 0, mid_to_long_term : 0, long_term : 0, risk_reduction : 0, risk_acception : 0, risk_transfer : 0, risk_evasion : 0, total_risk : 0};
    //     measureList.map(curr => {
    //         s_data.short_term = (s_data.short_term + curr.short_term);
    //         s_data.mid_to_long_term = (s_data.mid_to_long_term + curr.mid_to_long_term);
    //         s_data.long_term = (s_data.long_term + curr.long_term);
    //         s_data.risk_reduction= (s_data.risk_reduction + curr.risk_reduction);
    //         s_data.risk_acception = (s_data.risk_acception + curr.risk_acception);
    //         s_data.risk_transfer= (s_data.risk_transfer + curr.risk_transfer);
    //         s_data.risk_evasion = (s_data.risk_evasion + curr.risk_evasion);
    //         s_data.total_risk = (s_data.total_risk + curr.total_risk);
    //         return s_data;
    //     });
    //     setSumData(s_data);
    //   }, [measureList]);

    // 레포트 조회
    const findReportList = (reportId) => {
        if(reportId) {
            //통계 조회
            axios.get(getFindRiskResultManagement(reportId))
            .then((response) => {
                console.dir(response);

                // 데이타 핸들링을 위하여 Key값 추가
                const planList = response.data.statistic_compare;
                planList.map(item => {
                    if(item['result_init_cd'] === ""){
                        item['result_init_cd'] = item['result_cd'];
                    }
                });
                setPlanList(planList);
                // setItemList(response.data.statistic_risk_cd);
                // setMeasureList(response.data.statistic_risk_cd_type);
            })
            .catch((error) => {
                console.log("Riskmanagement.js ------- 82 에러");
                console.dir(error);
            })
            .finally(() => {
                setSpinflag(false);
            });
        }
    }

    // 닫기
    const onClickCloseHandler = () => {
        window.close();
    }

    // 탭클릭
    const onChangeTabHandler = (key) => {
        //console.log(key);
        setTabId(key);
    };

    //PDF다운로드
    const pdfDownload = () => {

        const report = document.getElementById('report');
        const data = document.getElementById('divTabs' + tabId);
        const div_height = data.style.height;
        data.style.height = (data.scrollHeight) + 'px';
        html2canvas(report).then((canvas) => {
        const margin = 6; // 출력 페이지 여백설정
        const imgWidth = 198;  // 208
        const pageHeight = 295;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = margin;
        heightLeft -= pageHeight;
        const doc = new jsPDF('p', 'mm', 'a4');
        doc.addImage(canvas, 'PNG', margin, position, imgWidth, imgHeight, '', 'FAST');
        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(canvas, 'PNG', margin, position, imgWidth, imgHeight, '', 'FAST');
            heightLeft -= pageHeight;
        }
        doc.save('RiskManagement_'+reportId+'.pdf');
        });
        //높이 재조정
        data.style.height = div_height;
    };
    
    const pdfDownLoadReport = (event) =>{
        setSpinflagMain(true);
        setLoadMessage("잠시만 기다려 주세요. 보고서 작성중 입니다...");
        let titleName="보고서 생성";
        
        const buttonType = event.currentTarget.textContent;

        if (buttonType === 'Markdown') {
            axios.get(getPdfDownload("riskmgmt_md", reportId)).then((response) => {
                setMarkdownContent(response.data);
                setMarkdownVisible(true);
                setSpinflagMain(false);
            }).catch((error) => {
                Modal.error({title:titleName,content:"Markdown 생성 중에 에러가 발생하였습니다.", okText:"Close"});
                setSpinflagMain(false);
            });
        }else{
            axios.get(getPdfDownload("riskmgmt", reportId)).then((response) => {

                if(response.data.status_url){
                    DownloadUrl(response.data.status_url,
                        () => setSpinflagMain(false), // onSuccess
                        (errorMessage) => {
                            Modal.error({title:titleName,content:errorMessage, okText:"Close"});
                            setSpinflagMain(false);
                        }
                    );
                }else{
                    Modal.error({title:titleName,content:"다운로드 중에 에러가 발생하였습니다.", okText:"Close"});
                    setSpinflagMain(false);
                }
            }).catch((error) => {
                Modal.error({title:titleName,content:"다운로드 중에 에러가 발생하였습니다.", okText:"Close"});
                setSpinflagMain(false);
            });  
        }         
    }

    // 정보 변경시 재조회
    useEffect(() => {
        if(isDataChange) {
            findReportList(reportId);
        }
    }, [isDataChange]);
/** -------------------------------------------------------------------------- **/
    return (
        <Spin size={"large"}  tip={loadMessage} spinning={spinflagMain}>
        <Layout style={{overflow: 'hidden'}}>
            <div className='popup_header'>
                <div className='popup_title'>
                   이행결과
                </div>
            </div>
            <div className="popup_button_report" style={{top: '10px'}}>
                <Button
                        type="default"
                        onClick={pdfDownLoadReport}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'Markdown'}
                </Button>
                <Button
                        type="default"
                        onClick={pdfDownLoadReport}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'보고서'}
                </Button>
                <Button
                    type="default"
                    onClick={onClickCloseHandler}
                    style={{marginLeft: '10px'}}
                    data-html2canvas-ignore="true"
                >
                    {'닫기'}
                </Button>
            </div>
            <div className="section" id="reportHeader">
                <ReportHeader reportId={reportId} reportInfo={reportInfo} setReportInfo={setReportInfo}/>
            </div>

                <PlanRs companyCode={companyCode} reportId={reportId} planList={planList} setIsDataChange={setIsDataChange} spinflag={spinflag} />
                 {/* <Content style={{ backgroundColor: '#f5f5f5'}}>
                    <Tabs defaultActiveKey="1" type={'card'} onChange={onChangeTabHandler}>
                        <TabPane tab={"이행점검결과"} key="1">
                            <PlanRs companyCode={companyCode} reportId={reportId} planList={planList} setIsDataChange={setIsDataChange} spinflag={spinflag} />
                        </TabPane>
                        <TabPane tab={"위험관리통계"} key="2">
                            <ItemRs itemList={itemList} measureList={measureList} sumData={sumData} spinflag={spinflag} />
                        </TabPane>
                    </Tabs>
                </Content> */}

        </Layout>
        <MarkdownViewerBig
            visible={markdownVisible}
            onClose={() => setMarkdownVisible(false)}
            markdownContent={markdownContent}
            reportId={reportId}
            reportName={reportName}
        />
        </Spin>
    );
}

export default ImplementResult;